<template>
  <div id="app">
    <nav-menu ></nav-menu>
      <keep-alive >
        <router-view></router-view>
      </keep-alive>
    <tabbar-mobile style="position: fixed"></tabbar-mobile>
  </div>
</template>
<script>
    import NavMenu from "./components/navbar/pc/NavMenu";
import TabbarMobile from "./mobile/components/tabbar/TabbarMobile";
import NavMenuMobile from "./mobile/components/NavMenuMobile";
  import Home from "./views/Home";
  import HomeM from "./views/HomeM";
  import {rem} from "./assets/js/rem";
  export default {
    name:'App',
    data(){
      return{
      }
    },
    components: {
      NavMenu,
      Home,
      HomeM,
      NavMenuMobile,
        TabbarMobile

    },
    created() {
    },
    mounted() {
      if (this._isMobile()) {
        // alert("手机端");
        this.$store.commit('aaa')
        this.$router.replace('/HomeMobile');
      } else {
        // alert("pc端");

        this.$store.commit('bbb')
        this.$router.replace('/Home');
      }
      // window.onresize = function(){
      //   var winWide = window.screen.width;  //获取当前屏幕分辨率
	  //   var wideScreen = false;
      //   if(winWide <= 1024){  //1024及以下分辨率
          //作用域有问题，无法调用this;
          // this.heiline;
          // this.$store.commit('aaa')
          // this.$router.replace('/HomeMobile');
        // }
        // else{  //大于1024的分辨率
          // this.$store.commit('bbb')
          // this.$router.replace('/Home');
        // };
      // }
    },
    methods:{
      _isMobile(){
        // (navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))
          let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
        return flag;
      }
    }
  }
</script>
<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}

</style>
